<template>
  <div class="bar-line-chart-v2-main" ref=barLineChartV2Main>
    <div class="chart-container" ref="chartContainer">
      <div class="yaxis-labels" :style="{ width: `${yAxisLabelWidth}px`, minWidth: `${yAxisLabelWidth}px` }">
        <div v-for="(y, i) in yAxisValueList" :key="i" class="y-axis-label-value"
          :style="{ top: `${yAxisInd[i]['y'] - 10}px` }">{{ y }}</div>
      </div>
      <div class="svg-container" ref="barSVGContainer" @scroll="svgContainerScrolled">
        <svg class="svg-chart" ref="svgChartBarLine" v-if="chartData.length > 0" :style="{ minWidth: `${((barWidth) * chartData.length) + 40}px` }">
          <!-- #region Bar Chart -->
          <g v-for="(d, di) in barChartData" :key="`DB${di}`">
            <rect v-for="(b, bi) in d" :key="`B${bi}`" :x="b['chartDetails']['x']" :y="0" :value="b['value']"
              :height="0" :width="b['chartDetails']['width']" :fill="b['chartDetails']['fill']"
              :transform="`scale(1, -1) translate(0, -${chartBottom})`" :fill-opacity="legendIsHover ? '0.2' : '1'" ref="barRect"
              @mouseover="barPointHover($event, b, di, 'in')"
              @mouseout="barPointHover($event, b, di, 'out')"
              @contextmenu="contextMenu">
              <animate attributeName="height" :from="0" :to="b['chartDetails']['height']" dur="0.2s" fill="freeze" :begin="bi * 0.1" />
            </rect>
          </g>
          <!-- #endregion -->
          
          <!-- #region Line Chart -->
          <path v-for="(p, pi) in lineChartPath" :key="`P${pi}`" :d="p" :stroke="getLineColor(pi)" stroke-width="3" fill="none"
            ref="linePath" :style="{ opacity: legendIsHover ? 0.2 : 1 }"></path>
          <g v-for="(d, di) in lineChartData" :key="`DL${di}`">
            <circle v-for="(l, li) in d" :key="`L${li}`" r="5" :cx="l['chartDetails']['x']" :cy="chartBottom - l['chartDetails']['height']"
              class="line-chart-point" :style="{ animationDelay: `${(lineChartAnimationTiming * di) + (li * (chartData.length / 2 * lineChartAnimationTiming))}s` }"
              :value="l['value']" ref="linePoint"
              :fill="l['chartDetails']['fill']" :fill-opacity="legendIsHover ? '0.2' : '1'"
              @mouseover="barPointHover($event, l, di, 'in')"
              @mouseout="barPointHover($event, l, di, 'out')">
            </circle>
          </g>
          <!-- #endregion -->

          <!-- #region Only show the line and value that is hovered on the legeend -->
          <g ref="chartHoverContainer"></g>
          <g ref="chartHoverContainerValue"></g>
          <!-- #endregion -->
        </svg>
        <div :style="{ height: '100%', width: '20px', position: 'absolute', top: 0, left: `${chartScrollLeft}px`, background: 'white' }"></div>
        <svg class="svg-chart" ref="svgChart" v-if="chartData.length > 0" :style="{ position: 'absolute', top: 0, left: `${chartScrollLeft}px`, pointerEvents: 'none' }">
          <!-- #region The graph lines (x and y axis) -->
          <path :d="xAxisLine" class="axis-lines" />
          <path :d="yAxisLine" class="axis-lines" />
          <!-- #endregion -->

          <!-- #region The indicator line along the y-axis -->
          <path v-for="(y, i) in yAxisInd" :key="i" :d="y['linePath']" class="ind-line" />
          <!-- #endregion -->
        </svg>
      </div>
      <div class="bar-line-chart-legend">
        <div>Legend</div>
        <div v-for="(d, i) in dataKeys" :key="i" class="bar-line-chart-legend-container"
          @mouseover="legendHover($event, d, i, 'in')"
          @mouseout="legendHover($event, d, i, 'out')">
          <div :class="[ 'bar-line-chart-legend-color', `${d['type']}-legend-style` ]" :style="{ backgroundColor: colors[i] }"></div>
          <div class="bar-line-chart-legend-name">{{ d['name'] }}</div>
        </div>
      </div>
    </div>
    <div class="xaxis-labels" ref="xAxisLabels" @scroll="xAxisLabelsScrolled" :style="{ left: `${yAxisLabelWidth}px`, maxWidth: `calc(100% - ${yAxisLabelWidth + 100 + 40}px)` }">
      <div v-for="(b, i) in chartData" :key="i" class="xaxis-label-value" ref="xaxisLabels"
        :style="{ width: `${b['width']}px`, left: `${b['x'] - (b['width'] / 2)}px` }"
        @mouseover="xAxisLabelHover($event, b, 'in')" @mouseout="xAxisLabelHover($event, b, 'out')">
        <div>{{ b['name'] }}</div>
      </div>
    </div>
    <div class="bar-line-context-menu" :style="contextMenuStyling" v-if="showContextMenu" ref="barLineContextMenu">
      <slot name="contextMenu">
      </slot>
      <div class="context-menu-item" v-for="( c, i) in contextMenus" :key="i" @click="contextMenuClicked(c)">{{ c }}</div>
      <div class="context-menu-item context-menu-close" @click="showContextMenu = false">Close</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      chartPadding: 10,

      xAxisLine: '',
      yAxisLine: '',

      yAxisInd: [],

      yAxisValueList: [],

      chartEl: null,
      chartRect: null,
      chartTop: 0,
      chartRight: 0,
      chartBottom: 0,
      chartLeft: 0,
      chartHeight: 0,
      chartWidth: 0,

      barWidth: 0,
      barMargin: 10,

      barChartData: [],
      lineChartData: [],
      chartScrollLeft: 0,
      
      chartType: '',
      privateBarData: [],
      privateLineData: [],
      chartData: [],
      chartValueFObject: null,
      lineChartPath: [],
      dataKeys: [],
      lineChartAnimationTiming: 0.1,

      legendIsHover: false,

      showContextMenu: false,
      contextMenuStyling: {
        left: 0,
        top: 0,
      }
    }
  },
  props: {
    data: { type: Array, default: function() { return [] } },
    colors: { type: Array, default: function() {
      return [
        '#FF0000', // Color 01 RED
        '#008000', // Color 02 GREEN
        '#f1f100', // Color 03 YELLOW
        '#0000FF', // Color 04 BLUE
        '#00FF00', // Color 05 LIME
        '#00FFFF', // Color 06 AQUA
        '#FF00FF', // Color 07 MAGENTA
        '#FF1493', // Color 08 DEEPPINK
        '#F5F5DC', // Color 09 BEIGE
        '#D3D3D3', // Color 10 LIGHTGRAY
        '#800000', // Color 11 MAROON
        '#ADD8E6', // Color 12 LIGHTBLUE
        '#FFC0CB', // Color 13 PINK
        '#808000', // Color 14 OLIVE
        '#2f4f4f', // Color 15 DARKSLATEGRAY
        '#00fa9a', // Color 16 MEDIUMSPRINGGREEN
        '#fa8072', // Color 17 SALMON
      ]
    } },
    yAxisLabelWidth: { type: Number, default: 50 },
    contextMenus: { type: Array, default: function() { return [] } },
  },
  methods: {
    initBar: function() {
      //#region Getting Max Value for y-axis
      let maxValue = 0;
      let allValues = this.chartData.map(l => l['value'].map(v => v['value'])).flat();
      if (typeof allValues[0] == 'number') {
        maxValue = (Math.max(...allValues));
      }
      //#endregion

      //#region Mark all y-axis values
      let yAxisCount = (this.chartRect.height * 2) / maxValue;
      if (yAxisCount > 15) { yAxisCount = 15 }
      else if (yAxisCount < 7) { yAxisCount = 7 }
      yAxisCount = Math.ceil(yAxisCount);

      let step = Math.ceil(maxValue / yAxisCount).toString();
      if (step.length > 1) {
        let expValue = step.length - 2 < 1 ? 1 : step.length - 2; expValue
        step = Math.ceil(Number(step) / Math.pow(10, expValue)) * Math.pow(10, expValue);
      }

      this.yAxisInd = [];
      this.yAxisValueList = [];
      let yAxisValue = 0;
      while (yAxisValue <= maxValue) {
        yAxisValue += Number(step);
        this.yAxisValueList.push(yAxisValue);
      }

      let yAxisStepHeight = (this.chartBottom - this.chartTop) / this.yAxisValueList.length;
      this.yAxisInd = this.yAxisValueList.map((y, i) => {
        return {
          linePath: `M0 ${this.chartBottom - (yAxisStepHeight * (i + 1))} L20 ${this.chartBottom - (yAxisStepHeight * (i + 1))}`,
          x: 0,
          y: this.chartBottom - (yAxisStepHeight * (i + 1))
        };
      })
      //#endregion

      //#region Drawing x and y axis
      this.xAxisLine = `M${this.chartLeft} ${this.chartBottom} L${this.chartRight} ${this.chartBottom}`;
      this.yAxisLine = `M${this.chartLeft} ${this.chartTop} L${this.chartLeft} ${this.chartBottom}`;
      //#endregion

      //#region Getting the keys for legend
      this.dataKeys = this.chartData.map(c => c['value'].map(v => ({ name: v['name'], type: v['type'] })))[0];
      //#endregion

      //#region Getting bar and line chart data
      this.barChartData = this.chartData.map(c => c['value'].filter(v => v['type'] == 'bar'));
      this.lineChartData = this.chartData.map(c => c['value'].filter(v => v['type'] == 'line'));
      //#endregion

      //#region Update the value for bar and line chart
      let maxYAxisValue = this.yAxisValueList[this.yAxisValueList.length - 1];
      for (let [i, b] of this.chartData.entries()) {
        let xPoint = (this.chartLeft + this.barMargin) + (this.barWidth * i);
        let width = this.barWidth - (this.barMargin * 2);
        let eachBarWidth = width / this.barChartData[0].length;
        eachBarWidth = eachBarWidth < 20 ? 20 : eachBarWidth;

        this.$set(b, 'width', width);
        this.$set(b, 'x', xPoint);
        b['value'].forEach((v, vi) => {
          this.$set(v, 'chartDetails', {});
          let pointValue = v['value'] || 0;

          this.$set(v, 'chartDetails', {
            x: v['type'] == 'bar' ? xPoint + (vi * eachBarWidth) : xPoint + (width / 2),
            height: pointValue * this.chartHeight / maxYAxisValue,
            width: eachBarWidth,
            fill: this.colors[vi]
          })
        })
      }
      //#endregion

      //#region Drawing the lines of the line chart
      this.lineChartPath = [];
      let allLines = this.lineChartData.flat();
      this.dataKeys.filter(d => d['type'] == 'line').forEach(l => {
        let current = allLines.filter(a => a['name'] == l['name']);
        let pathPoints = current.map(c => `${c['chartDetails']['x']} ${this.chartBottom - c['chartDetails']['height']}`);
        this.lineChartPath.push(`M${pathPoints.join(' L')}`);
      })

      if (this.$refs['linePath']) {
        Array.from(this.$refs['linePath']).forEach((p, i) => {
          let pathLength = p.getTotalLength();
          p.style.strokeDasharray = pathLength;
          p.style.strokeDashoffset = pathLength;
          p.style.animation = `drawPath ${this.lineChartAnimationTiming * (this.chartData.length - 1)}s linear forwards`;
          p.style.animationDelay = `${(this.lineChartAnimationTiming * this.chartData.length / 2) * (i + 1)}s`;
        })
      }
      //#endregion

      // console.log(this.barChartData, this.lineChartData);
    },

    xAxisLabelHover: function(e, data, type) {
      if (type == 'in') {
        e.target.style.transform = `rotate(0) translate(${(this.barWidth / 2) - 10}px, 0)`;
        e.target.style.justifyContent = `center`;
        e.target.style.fontSize = `1em`;
        e.target.style.zIndex = `1`;
        e.target.style.fontWeight = `bold`;
        e.target.style.backgroundColor = `white`;
      } else {
        e.target.style.transform = `rotate(-45deg)`;
        e.target.style.justifyContent = `flex-end`;
        e.target.style.fontSize = `0.8em`;
        e.target.style.zIndex = `0`;
        e.target.style.fontWeight = `normal`;
        e.target.style.backgroundColor = `transparent`;
      }
    },
    barPointHover: function(e, data, xAxisIndex, type) {
      this.xAxisLabelHover({ target: this.$refs['xaxisLabels'][xAxisIndex] }, data, type);
      if (type == 'in') {
        this.showChartValue(data);
      } else if (this.chartValueFObject) {
        this.$refs['svgChart'].removeChild(this.chartValueFObject);
        this.chartValueFObject = null;
      }
    },
    linePointHover: function(e, data, key, xAxisIndex, type) {
      this.xAxisLabelHover({ target: this.$refs['xaxisLabels'][xAxisIndex] }, data, type);
      if (type == 'in') {
        this.showChartValue(data, key);
      } else if (this.chartValueFObject) {
        this.$refs['svgChart'].removeChild(this.chartValueFObject);
        this.chartValueFObject = null;
      }
    },
    legendHover: function(e, data, legendIndex, type) {
      this.legendIsHover = type == 'in';

      if (type == 'out') {
        this.$refs['chartHoverContainer'].innerHTML = '';
        this.$refs['chartHoverContainerValue'].innerHTML = '';
        return;
      }

      let isBar = data['type'] == 'bar';

      let elementRef = isBar ? 'barRect' : 'linePoint';
      let allElements = Array.from(this.$refs[elementRef]);
      let hoverElements = [];

      let keyLength = this.dataKeys.length;
      for (let i = 0; i < this.chartData.length; i++) {
        hoverElements.push(allElements.slice(keyLength * i, keyLength * (i + 1))[legendIndex].cloneNode(true));
      }

      if (!isBar) {
        let hoverPath = this.$refs['linePath'][legendIndex].cloneNode();
        hoverPath.style = '';
        this.$refs['chartHoverContainer'].appendChild(hoverPath);
      }

      hoverElements.forEach(h => {
        let xPos = 0;
        let yPos = 0;

        if (isBar) {
          let animateObj = h.children[0];
          let height = animateObj.getAttribute('to');
          h.setAttribute('height', height);
          h.removeChild(animateObj);
          
          xPos = Number(h.getAttribute('x')) + (Number(h.getAttribute('width')) / 2);
          yPos = this.chartBottom - Number(h.getAttribute('height'));
        } else {
          h.style = '';
          xPos = Number(h.getAttribute('cx'));
          yPos = Number(h.getAttribute('cy'));
        }

        this.$refs['chartHoverContainer'].appendChild(h);
        this.appendLegendHoverValues(xPos, yPos, h.getAttribute('value'));
      })
    },

    showChartValue: function(data) {
      let arrowIsLeft = false;
      let yPosition = this.chartBottom - data['chartDetails']['height'];
      let xPosition = (data['chartDetails']['x'] - (data['type'] == 'bar' ? 150 : 155)) - this.chartScrollLeft;
      if (xPosition < 0) {
        xPosition = (data['chartDetails']['x'] + (data['type'] == 'bar' ? data['chartDetails']['width'] : 5)) - this.chartScrollLeft;
        arrowIsLeft = true;
      }
      this.chartValueFObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
      this.chartValueFObject.setAttribute('x', xPosition);
      this.chartValueFObject.setAttribute('width', 150);

      let valueContainer = document.createElement('div');
      valueContainer.style.width = '100%';
      valueContainer.style.textAlign = 'center';
      valueContainer.style.position = 'relative';

      let arrow = document.createElement('div');
      arrow.style.position = 'absolute';
      arrow.style.left = arrowIsLeft ? '-10px' : 'calc(100% - 10px)';
      arrow.style.transform = `rotate(${arrowIsLeft ? '180' : '0'}deg)`;
      arrow.style.height = '20px';
      arrow.style.width = '20px';
      arrow.style.borderStyle = 'solid';
      arrow.style.borderWidth = '10px';
      arrow.style.borderColor = `transparent transparent transparent gray`;

      let text = document.createElement('div');
      text.style.position = 'relative';
      text.style.backgroundColor = 'white';
      text.style.border = `1px solid gray`;
      text.style.width = 'calc(100% - 10px)';
      text.style.left = arrowIsLeft ? '10px' : '0';
      text.innerHTML = `${data['name']}<br>${data['value']}`;

      valueContainer.appendChild(arrow);
      valueContainer.appendChild(text);

      this.chartValueFObject.appendChild(valueContainer);

      this.$refs['svgChart'].appendChild(this.chartValueFObject);

      this.$nextTick(() => {
        let valueHeight = valueContainer.getBoundingClientRect().height;
        let newYPosition = yPosition - (valueHeight / 2);
        
        arrow.style.top = `${(valueHeight / 2) - 10}px`;
        if (newYPosition < 0) {
          newYPosition = 0;
        } else if(newYPosition + valueHeight > this.chartBottom) {
          newYPosition = this.chartBottom - valueHeight;
          arrow.style.top = `${valueHeight - 10}px`;
        }
        this.chartValueFObject.setAttribute('height', valueHeight);
        this.chartValueFObject.setAttribute('y', newYPosition);
      });
    },
    appendLegendHoverValues: async function(x, y, text) {
      let fObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');

      let value = document.createElement('div');
      value.style.backgroundColor = 'white';
      value.style.width = 'fit-content';
      value.style.whiteSpace = 'nowrap';
      value.style.padding = '5px';
      value.style.border = '1px solid';
      value.innerHTML = text;

      fObject.appendChild(value);
      this.$refs['chartHoverContainerValue'].appendChild(fObject);

      await this.$nextTick();

      let valueRect = value.getBoundingClientRect();
      fObject.setAttribute('height', valueRect.height);
      fObject.setAttribute('width', valueRect.width)

      let xPos = x - (valueRect.width / 2);
      let yPos = y - valueRect.height - 5;
      if (yPos < this.chartTop) {
        yPos = Number(y) + 5;
      }
      fObject.setAttribute('x', xPos);
      fObject.setAttribute('y', yPos);
    },

    svgContainerSizeChanged: function() {
      this.chartEl = this.$refs['svgChart'];
      if (this.chartEl) {
        this.chartRect = this.chartEl.getBoundingClientRect();
        
        this.chartTop = this.chartPadding;
        this.chartRight = this.chartRect.width - this.chartPadding;
        this.chartBottom = this.chartRect.height - this.chartPadding;
        this.chartLeft = this.chartPadding;
        this.chartHeight = this.chartBottom - this.chartTop;
        // this.chartWidth = this.chartRight - this.chartLeft;
        let chartContainer = this.$refs['chartContainer'];
        let chartContainerRect = chartContainer.getBoundingClientRect();
        this.chartWidth = chartContainerRect.width - this.yAxisLabelWidth - 100 - 40;

        if (this.chartData.length > 0) {
          let barCount = this.chartData[0].value.filter(v => v.type == 'bar').length;
          let minBarWidth = barCount * 20 + (barCount * 5);
          this.barWidth = (this.chartWidth - 10) / this.chartData.length;
          this.barWidth = this.barWidth < minBarWidth ? minBarWidth : this.barWidth;
        }

        this.initBar();
      }
    },

    svgContainerScrolled: function(e) {
      this.showContextMenu = false;
      this.$refs['xAxisLabels'].scrollTo({ left: e.target.scrollLeft });
      this.chartScrollLeft = e.target.scrollLeft;
    },
    xAxisLabelsScrolled: function(e) {
      this.showContextMenu = false;
      this.$refs['barSVGContainer'].scrollTo({ left: e.target.scrollLeft });
      this.chartScrollLeft = e.target.scrollLeft;
    },

    getLineColor: function(ind) {
      let barCount = this.chartData[0].value.filter(v => v.type == 'bar').length;
      return this.colors[barCount + ind];
    },

    contextMenu: function(e) {
      e.preventDefault();
      let mainContainer = this.$refs['barLineChartV2Main'];
      let mainContainerRect = mainContainer.getBoundingClientRect();

      this.contextMenuStyling = {
        left: `${e['pageX'] - mainContainerRect.left}px`,
        top: `${e['pageY'] - mainContainerRect.top}px`,
      };
      this.showContextMenu = true;

      this.$nextTick(() => {
        let contextMenu = this.$refs['barLineContextMenu'];
        let contextMenuRect = contextMenu.getBoundingClientRect();

        if (contextMenuRect.bottom > mainContainerRect.bottom) {
          let currentTop = Number(this.contextMenuStyling['top'].match(/\d/g).join(''));
          this.contextMenuStyling['top'] = `${currentTop - contextMenuRect.height}px`;
        }

        if (contextMenuRect.right > mainContainerRect.right) {
          let currentLeft = Number(this.contextMenuStyling['left'].match(/\d/g).join(''));
          this.contextMenuStyling['left'] = `${currentLeft - contextMenuRect.width}px`;
        }
      })
    },
    contextMenuClicked: function(item) {
      this.showContextMenu = false;
      this.$emit('contextMenuClicked', item);
    },
  },
  mounted() {
    if (this.data.length > 0) {
      this.data.forEach(d => {
        d['value'].forEach(v => {
          if (!v['type']) {
            v['type'] = 'bar';
          }
        })
      })

      this.chartData = this.data;
    }

    let observer = new ResizeObserver(this.svgContainerSizeChanged);
    observer.observe(this.$refs['barSVGContainer']);
  },
  watch: {
    data: async function(val) {
      this.chartData = [];
      this.barChartData = [];
      this.lineChartData = [];

      if (val) {
        await this.$nextTick();
        if (val.length > 0) {
          val.forEach(d => {
            d['value'].forEach(v => {
              if (!v['type']) {
                v['type'] = 'bar';
              }
            })
          })
        }
        this.chartData = val;

        await this.$nextTick();
        this.svgContainerSizeChanged();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.bar-line-chart-v2-main {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  position: relative;

  > .chart-container {
    height: 100%;
    width: 100%;
    display: flex;
    position: relative;

    > .svg-container {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: overlay;

      > .svg-chart {
        width: 100%;
        height: 100%;

        > .axis-lines {
          stroke: black;
          stroke-width: 1;
        }

        > .ind-line {
          stroke: black;
          stroke-width: 1;
        }
      }

      &::-webkit-scrollbar-thumb {
        background: transparent;
      }
    }

    > .yaxis-labels {
      position: relative;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      > .y-axis-label-value {
        position: absolute;
        width: 100%;
        height: 20px;
        min-height: 20px;
        max-height: 20px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 5px;
        left: 0;
      }
    }

    > .bar-line-chart-legend {
      height: 100%;
      min-width: 100px;
      
      > .bar-line-chart-legend-container {
        display: flex;
        align-items: center;
        padding: 3px 0;
        cursor: pointer;

        &:hover {
          font-weight: bold;
        }
        
        > .bar-line-chart-legend-color {
          pointer-events: none;
        }

        > .line-legend-style {
          min-height: 7px;
          max-height: 7px;
          min-width: 21px;
          max-width: 21px;
        }

        > .bar-legend-style {
          min-height: 20px;
          max-height: 20px;
          min-width: 20px;
          max-width: 20px;
        }
  
        > .bar-line-chart-legend-name {
          margin-left: 5px;
          pointer-events: none;
        }
      }
    }
  }

  > .xaxis-labels {
    position: relative;
    width: 100%;
    min-height: 50px;
    display: flex;
    overflow: overlay;
    overflow-y: hidden;

    > .xaxis-label-value {
      position: absolute;
      height: 100%;
      display: flex;
      // border: 1px solid;
      align-items: flex-start;
      justify-content: flex-end;
      white-space: nowrap;
      font-size: 0.8em;
      top: -8px;
      transform-origin: top right;
      transform: rotate(-45deg);
      cursor: default;
      // transition: 0.3s;

      > div {
        pointer-events: none;
        padding: 5px;
      }
    }
  }

  > .bar-line-context-menu {
    background-color: rgb(76, 76, 76);
    position: absolute;
    color: white;
    border: 1px solid rgb(175, 175, 175);
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 100px;
    max-width: 150px;
    z-index: 1;

    > .context-menu-item {
      padding: 5px;
      user-select: none;
      cursor: pointer;

      &:hover {
        background-color: rgb(175, 175, 175);
        color: black;
      }
    }

    > .context-menu-close {
      border-top: 1px solid rgb(175, 175, 175);
    }
  }
}

.bar-value {
  height: 100%;
  width: 100%;
  text-align: center;
  font-weight: bold;
}

.line-chart-point {
  opacity: 0;
  animation: showPoint 0.1s linear forwards;
}

@keyframes showPoint {
  to { opacity: 1; }
}
</style>

<style lang="scss">
@keyframes drawPath {
  to { stroke-dashoffset: 0; }
}
</style>